import { render } from "./AdminDashboardComponent.vue?vue&type=template&id=31aa42ab&scoped=true"
import script from "./AdminDashboardComponent.vue?vue&type=script&lang=js"
export * from "./AdminDashboardComponent.vue?vue&type=script&lang=js"

import "./AdminDashboardComponent.vue?vue&type=style&index=0&id=31aa42ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31aa42ab"]])

export default __exports__